/*  MUI  */
import { Typography } from '@mui/material';

/*  Shared  */
import { Helpers } from 'application/Shared/Helpers';

/*  NPM  */
import equal from 'fast-deep-equal';

/*  React  */
import React, { Component } from 'react';
import { Link } from 'react-router';

/*  Components  */
import { DataCard } from './Components/DataCard';

/*  State  */
const state = () => ({
    count: 0,
    loaded: false,
    percentage: 0,
    total: 0
});

class Percentage extends Component {
    constructor(props) {
        super(props);
        this.state = state();
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prev) {
        const { data } = this.props;
        if (!equal(data, prev.data)) {
            this.reload();
        }
    }

    load = () => {
        const { accessorKey, data, total } = this.props;
        let { count } = this.props;

        if (Helpers.isEmpty(data)) {
            this.calc({ count, total });
            return;
        }

        count = 0;
        data.forEach((d) => {
            if (!Helpers.isset(d, accessorKey)) {
                return;
            }

            if (d[accessorKey]) {
                count += 1;
            }
        });

        this.calc({ count, total: Helpers.count(data) });
    };

    calc = (p) => {
        const { count, total } = p;

        if (!count || !total) {
            this.setState({ loaded: true });
            return;
        }

        const percentage = parseInt((count / total) * 100, 10);
        this.setState({ count, loaded: true, percentage, total });
    };

    reload = () => {
        this.setState(state(), () => this.load());
    };

    renderData = () => {
        const { color } = this.props;
        const { percentage, count, total } = this.state;

        const currentColor = color || 'text.cardKPI';

        return (
            <>
                <Typography variant="h1" sx={{ color: currentColor }}>
                    {percentage}%
                </Typography>
                <Typography
                    sx={{ color: currentColor }}
                    variant="body2"
                    marginTop="4px"
                >
                    {count} / {total}
                </Typography>
            </>
        );
    };

    renderCard = () => {
        const { title, subtitle, filteredResults, tooltip, loading, height } =
            this.props;

        return (
            <DataCard
                title={title}
                subtitle={subtitle}
                filteredResults={filteredResults}
                tooltip={tooltip}
                height={height}
                loading={loading}
            >
                {this.renderData()}
            </DataCard>
        );
    };

    render() {
        const { noCard, link } = this.props;
        const { loaded } = this.state;

        if (!loaded) {
            return null;
        }

        if (noCard) {
            return this.renderData();
        }

        if (!link) {
            return this.renderCard();
        }

        return (
            <Link
                to={link}
                className="link"
                data-trackid="cards_percentage_routeTo"
            >
                {this.renderCard()}
            </Link>
        );
    }
}

export default Percentage;
